import styled from '@emotion/styled';

const CommentsWrapper = styled('ul')({
  marginTop: 0,
  marginBottom: 0,
  paddingLeft: 0,
  listStyle: 'none',
});

export default CommentsWrapper;
